import React from "react";
import "../../styles/OverviewTab.css";

const OverviewTab = ({ payment }) => {

    if (!payment) return null;

    return (

        <div className="overview-grid">

            <div className="overview-card">

                <h3>Payment Information</h3>

                <p>
                    <strong>Payment No :</strong>
                    {payment.paymentNumber}
                </p>

                <p>
                    <strong>Order No :</strong>
                    {payment.orderNumber}
                </p>

                <p>
                    <strong>Status :</strong>
                    {payment.payment?.status}
                </p>

                <p>
                    <strong>Gateway :</strong>
                    {payment.payment?.gateway}
                </p>

                <p>
                    <strong>Method :</strong>
                    {payment.payment?.method}
                </p>

                <p>
                    <strong>Transaction :</strong>
                    {payment.payment?.transactionId}
                </p>

            </div>

            <div className="overview-card">

                <h3>Pricing</h3>

                <p>
                    Food Total :
                    ₹{payment.pricing?.foodTotal}
                </p>

                <p>
                    Delivery :
                    ₹{payment.pricing?.deliveryCharge}
                </p>

                <p>
                    Tax :
                    ₹{payment.pricing?.tax}
                </p>

                <p>
                    Discount :
                    ₹{payment.pricing?.discount}
                </p>

                <p>
                    Platform Fee :
                    ₹{payment.pricing?.platformFee}
                </p>

                <hr />

                <h2>
                    ₹{payment.pricing?.grandTotal}
                </h2>

            </div>

        </div>

    );

};

export default OverviewTab;